module.exports = __webpack_public_path__ + "static/cercazone_centro3-46dcf3a92b0c1feebe782ad47dc9769f.jpg";